import { TableCell } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

export const StyledTableHeaderCell = withStyles(() => ({
  root: {
    backgroundColor: '#FFFFFF',
    fontWeight: '700',
    paddingLeft: '24px',
    paddingRight: '24px',
  },
}))(TableCell);
